var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-y-transition',{attrs:{"group":""}},[(_vm.ready && _vm.currentComponent)?_c(_vm.currentComponent,{key:_vm.currentStep,tag:"component",attrs:{"loan":_vm.loan},on:{"delegation-complete":_vm.handleDelegationComplete,"contract-complete":_vm.handleContractComplete}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }